import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";
import infoIcon from "../../assets/img/info-circle.svg";
import { formatCurrency } from "../../constants/utils";
import { getPriceAdjustmentConfig } from "../../constants/priceAdjustment";
import "./DiscountTooltip.scss";

const DiscountTooltip = ({
  discountMap,
  discountType,
  targetId,
  currencyCode,
  priceAdjustment,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  const { prefix, colorClass } = getPriceAdjustmentConfig(priceAdjustment);

  const dayNames = {
    1: "Sun",
    2: "Mon",
    3: "Tue",
    4: "Wed",
    5: "Thu",
    6: "Fri",
    7: "Sat",
  };

  const formatDiscount = (value) => {
    if (discountType === "1") {
      // Flat discount - use formatCurrency with currency symbol
      return `${prefix}${formatCurrency(Number.parseFloat(value), currencyCode)}`;
    }
    // Percentage discount - show with % symbol
    return `${prefix}${value}%`;
  };

  return (
    <>
      <span id={targetId} className={`discount-daily-label ${colorClass}`}>
        Daily&nbsp;
        <img
          src={infoIcon}
          alt="Info"
          className="discount-info-icon"
          width="20"
          height="20"
        />
      </span>
      <Tooltip
        placement="top"
        isOpen={tooltipOpen}
        target={targetId}
        toggle={toggle}
        className="discount-tooltip"
      >
        <div className="discount-breakdown">
          {Object.entries(discountMap).map(([dayNum, value]) => (
            <div key={dayNum} className="discount-row">
              <span className="day-name">{dayNames[dayNum]}:</span>
              <span className={`discount-value ${colorClass}`}>
                {formatDiscount(value)}
              </span>
            </div>
          ))}
        </div>
      </Tooltip>
    </>
  );
};

DiscountTooltip.propTypes = {
  discountMap: PropTypes.objectOf(PropTypes.number).isRequired,
  discountType: PropTypes.string.isRequired,
  targetId: PropTypes.string.isRequired,
  currencyCode: PropTypes.string,
  priceAdjustment: PropTypes.string.isRequired,
};

export default DiscountTooltip;
